// extracted by mini-css-extract-plugin
export default {"container":"cookies-banner-module--container--01G8p","link":"cookies-banner-module--link--zvQ4S","button":"cookies-banner-module--button--gMRRB"};